import { LDLAirQuality } from '../LDLAirQuality/LDLAirQuality';
import { LDLAlertHeadlines } from '../LDLAlertHeadlines/LDLAlertHeadlines';
import { LDLHourly } from '../LDLHourly/LDLHourly';
import { LDLNow } from '../LDLNow/LDLNow';
import { LDLPollen } from '../LDLPollen/LDLPollen';
import { LDLSunriseSunset } from '../LDLSunriseSunset/LDLSunriseSunset';
import { LDLThreeDay } from '../LDLThreeDay/LDLThreeDay';
import { LDLTodayTonight } from '../LDLTodayTonight/LDLTodayTonight';
import { LDLTomorrow } from '../LDLTomorrow/LDLTomorrow';
import { LDLTwoDay } from '../LDLTwoDay/LDLTwoDay';

export const ldlProductMap = {
  alertHeadlines: LDLAlertHeadlines,
  now: LDLNow,
  todayTonight: LDLTodayTonight,
  tomorrow: LDLTomorrow,
  hourly: LDLHourly,
  pollen: LDLPollen,
  airQuality: LDLAirQuality,
  sunriseSunset: LDLSunriseSunset,
  twoDay: LDLTwoDay,
  threeDay: LDLThreeDay,
};
